export const PrimaryAppColor = '#3367FB';
